// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"484":"6407f3495d54820cc32a","596":"2901d8dbb6b093bde528"}[chunkId] + ".js";
};